import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/articles' },
    {
      path: '/articles',
      component: () => import('./views/ArticlesView.vue'),
    },
    {
      path: '/articles/:id',
      component: () => import('./views/ArticleDetailView.vue'),
    },
    {
      path: '/channels',
      component: () => import('./views/ChannelsView.vue'),
    },
    {
      path: '/videos',
      component: () => import('./views/VideosView.vue'),
    },
    {
      path: '/digest',
      component: () => import('./views/DigestView.vue'),
    },
    {
      path: '/digest/daily',
      component: () => import('./views/DigestDailyView.vue'),
    },
    {
      path: '/digest/weekly',
      component: () => import('./views/DigestWeeklyView.vue'),
    },
    {
      path: '/digest/daily/:id',
      component: () => import('./views/DigestDetailView.vue'),
      props: true,
    },
    {
      path: '/digest/weekly/:id',
      component: () => import('./views/DigestDetailView.vue'),
      props: true,
    },
    {
      path: '/settings',
      component: () => import('./views/SettingsView.vue'),
    },
  ],
});
